import { States } from 'safe'
import {
  SET_BANK_ACCOUNTOLD,
  SET_BANK_ACCOUNTSOLD,
  UPDATE_BANK_ACCOUNTOLD,
  DELETE_BANK_ACCOUNTOLD,
  BankAccountsTypesOld,
} from '../actions/actionTypes'

const initialState: States.BankAccountOld = {
  bank_accounts: [],
}

//eslint-disable-next-line
export default (
  state = initialState,
  action: BankAccountsTypesOld
): States.BankAccountOld => {
  let _accounts, aIndex
  switch (action.type) {
    case SET_BANK_ACCOUNTSOLD:
      return { ...state, bank_accounts: action.payload }
    case SET_BANK_ACCOUNTOLD:
      return {
        ...state,
        bank_accounts: [...state.bank_accounts, action.payload],
      }
    case UPDATE_BANK_ACCOUNTOLD:
      _accounts = [...state.bank_accounts]
      aIndex = _accounts.findIndex((i) => i.id === action.payload.id)
      _accounts[aIndex] = { ..._accounts[aIndex], ...action.payload }
      return { ...state, bank_accounts: _accounts }
    case DELETE_BANK_ACCOUNTOLD:
      _accounts = [...state.bank_accounts]
      aIndex = _accounts.findIndex((i) => i.id === action.payload.id)
      _accounts.splice(aIndex, 1)
      return { ...state, bank_accounts: _accounts }
    default:
      return state
  }
}
